import { Directive, inject } from '@angular/core';
import { RegisterProbateFormService } from '../register-probate-form.service';
import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { ConfirmationModalComponent } from '@shared/components/confirmation-modal/confirmation-modal.component';
import { ConfirmationModalData } from '@shared/components/confirmation-modal/confirmation-modal.model';
import { filter, tap } from 'rxjs';
import { getConfirmationData } from '../../../shared/helpers/get-confirmation-data.helper';
import { ClerkCreateEstateFacadeService } from '../clerk-create-estate-facade.service';

@Directive({
  selector: '[appHandleClerkCreateEstateSubmit]',
  host: { '(ngSubmit)': 'handleClick()' },
})
export class HandleClerkCreateEstateSubmitDirective {
  private readonly _formService = inject(RegisterProbateFormService);
  private readonly _dialog = inject(Dialog);
  private readonly _submitFacade = inject(ClerkCreateEstateFacadeService);
  private readonly _dialogRef = inject(DialogRef);

  private readonly _form = this._formService.registerForm;

  private readonly _confirmationData: ConfirmationModalData =
    getConfirmationData('Estate');

  protected handleClick() {
    const isLinkingUser = this._form.controls.userId.value !== 0;
    if (!isLinkingUser) {
      this._dialogRef.close();
      this._submitFacade.submitApplication();
      return;
    }

    this._dialogRef.close();
    const dialogRef = this._dialog.open(ConfirmationModalComponent, {
      data: this._confirmationData,
    });

    dialogRef.closed
      .pipe(
        filter((confirmed) => !!confirmed),
        tap(() => {
          this._submitFacade.submitApplication();
        }),
      )
      .subscribe();
  }
}
